import { render, staticRenderFns } from "./scroller.vue?vue&type=template&id=2a6e1784"
import script from "./scroller.vue?vue&type=script&lang=js"
export * from "./scroller.vue?vue&type=script&lang=js"
import style0 from "./scroller.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports